module.exports = __webpack_public_path__ + "static/media/UserSuspended.66be7a21.svg";